<template>
    <add-edit-subcription-plan></add-edit-subcription-plan>
</template>
<script>
import AddEditSubcriptionPlan from "@/layouts/components/subcriptionPlan/addEditSubcriptionPlan"
  export default {
    components: {
      'add-edit-subcription-plan':AddEditSubcriptionPlan
    }
  }
</script>